import {getDataInLocalStorage} from "@/utils/localStorage";

export const leftNavData = [
    {
        title: '客户信息',
        icon: 'el-icon-user',
        path: '/customer',
        role: ['ADMIN','MANAGER','SALES_MANAGER','SALES_ASSI','SALES_ASSI_MANAGER','SALES'],
        sonMenu: [
            {
                title: '客户联系人',
                icon: 'el-icon-user',
                path: '/customerUser',
                role: ['ADMIN','MANAGER','SALES_MANAGER','SALES_ASSI','SALES_ASSI_MANAGER','SALES'],
                sonMenu: []
            },
            {
                title: '客户单位',
                icon: 'el-icon-edit-outline position-relative',
                path: '/customerCompany',
                role: ['ADMIN','MANAGER','SALES_MANAGER','SALES_ASSI','SALES_ASSI_MANAGER','SALES'],
                sonMenu: []
            },
            {
                title: '客户课题组',
                icon: 'el-icon-school',
                path: '/customerGroup',
                role: ['ADMIN','MANAGER','SALES_MANAGER','SALES_ASSI','SALES_ASSI_MANAGER','SALES'],
                sonMenu: []
            },
        ]
    },
    {
        title: '信息统计',
        icon: 'el-icon-s-data',
        path: '/informationStatistics',
        role: ['ADMIN', 'MANAGER', 'SALES_MANAGER', 'SALES', 'SALES_ASSI', 'SALES_ASSI_MANAGER', 'TECH', 'FINANCE'],
        sonMenu: []
    },
    {
        title: '扣除记录',
        icon: 'el-icon-data-line',
        path: '/deductionRecords',
        role: ['ADMIN', 'BUSINESS_COMMERCIAL', 'MANAGER', 'SALES_MANAGER', 'SALES_ASSI', 'SALES_ASSI_MANAGER', 'SALES'],
        sonMenu: []
    },
    {
        title: '合同申请',
        icon: 'el-icon-document-remove',
        path: '/salesContract',
        role: ['ADMIN', 'SALES_MANAGER', 'SALES_ASSI', 'SALES_ASSI_MANAGER', 'SALES', 'MANAGER', 'APPROVAL_SPECIALIST', 'FINANCE', 'AUDITOR'],
        redDotFc: 'getSubmittedRedDoltNum',
        type:false,
        sonMenu: []
    },
    {
        title: '商务审批',
        icon: 'el-icon-document-checked',
        path: '/check',
        role: ['ADMIN', 'MANAGER', 'FINANCE', 'CASHIER', 'BUSINESS_COMMERCIAL', 'LAB', 'APPROVAL_SPECIALIST', 'SALES_MANAGER', 'SALES'],
        redDotFc: 'getAuditRedDoltNum',
        type:false,
        sonMenu: [
            {
                title: '合同审批',
                icon: 'el-icon-s-order',
                path: '/contractCheck',
                role: ['ADMIN', 'MANAGER', 'APPROVAL_SPECIALIST', 'SALES_MANAGER', 'SALES'],
                redDotFc: 'getContractRedDoltNum',
                type:'audit',
                sonMenu: []
            },
            {
                title: '合同变更审批',
                icon: 'el-icon-s-claim',
                path: '/contractChange',
                role: ['ADMIN', 'MANAGER', 'APPROVAL_SPECIALIST', 'SALES_MANAGER', 'SALES'],
                redDotFc: 'getContractChangeDoltNum',              
                type:false,
                sonMenu: []
            },
            {
                title: '团队费用审批',
                icon: 'el-icon-s-check',
                path: '/teamContractAudit',
                role: ['ADMIN', 'MANAGER', 'SALES_MANAGER', 'SALES'],
                redDotFc: 'getTeamAuditDoltNum',
                type:false,
                sonMenu: []
            },
            {
                title: '正式合同抵扣审批',
                icon: 'el-icon-s-claim',
                path: '/offSetAudit',
                role: ['ADMIN', 'MANAGER', 'APPROVAL_SPECIALIST', 'SALES_MANAGER', 'SALES'],
                redDotFc: 'getOffSetDoltNum',              
                type:false,
                sonMenu: []
            },

            {
                title: '合同终止审批',
                icon: 'el-icon-warning',
                path: '/terminateApply',
                role: ['ADMIN', 'LAB', 'MANAGER', 'APPROVAL_SPECIALIST', 'SALES_MANAGER', 'SALES'],
                redDotFc: 'getTerminateApplyDoltNum',
                type:false,
                sonMenu: []
            },
            {
                title: '开票审批',
                icon: 'el-icon-s-ticket',
                path: '/recordCheck',
                role: ['ADMIN', 'MANAGER', 'BUSINESS_COMMERCIAL', 'SALES_MANAGER', 'SALES'],
                redDotFc: 'getRecordRedDoltNum',
                type:false,
                sonMenu: []
            },
            {
                title: '退票审批',
                icon: 'el-icon-s-finance',
                path: '/refundAudit',
                role: ['ADMIN', 'MANAGER', 'SALES_MANAGER', 'SALES'],
                redDotFc: 'getInvoiceRedDoltNum',
                type:'refundAudit',
                sonMenu: []
            },
            {
                title: '项目款认领审批',
                icon: 'el-icon-s-ticket',
                path: '/paymentCheck',
                role: ['ADMIN', 'FINANCE', 'CASHIER', 'MANAGER', 'SALES_MANAGER', 'SALES'],
                redDotFc: 'getClaimAuditRedDoltNum',
                type:false,
                sonMenu: []
            },
            {
                title: '垫付款认领审批',
                icon: 'el-icon-monitor',
                path: '/advanceCheck',
                role: ['ADMIN', 'FINANCE', 'CASHIER', 'MANAGER', 'SALES_MANAGER', 'SALES'],
                redDotFc: 'getAdvanceAuditRedDoltNum',
                type: false,
                sonMenu: []
            },
            {
                title: '转预付款',
                icon: 'el-icon-s-order',
                path: '/impairment',
                role: ['ADMIN', 'MANAGER', 'SALES_MANAGER', 'SALES'],
                sonMenu: []
            },
            {
                title: '预付款转移',
                icon: 'el-icon-s-management',
                path: '/transferContract',
                role: ['ADMIN', 'MANAGER', 'SALES_MANAGER', 'SALES'],
                sonMenu: []
            },
        ]
    },
    {
        title: '发票信息',
        icon: 'el-icon-wallet',
        path: '/tickets',
        role: ['ADMIN','SALES_MANAGER','SALES_ASSI','SALES_ASSI_MANAGER','SALES','FINANCE','CASHIER','MANAGER','BUSINESS_COMMERCIAL'],
        sonMenu: []
    },
    {
        title: '邮寄/扫描信息',
        icon: 'el-icon-position',
        path: '/mail',
        role: ['ADMIN','SALES_MANAGER','SALES_ASSI','SALES_ASSI_MANAGER','SALES','MANAGER','BUSINESS_COMMERCIAL'],
        sonMenu: []
    },
    {
        title: '商务流转',
        icon: 'el-icon-folder-checked',
        path: '/amountInfo',
        role: ['ADMIN','BUSINESS_COMMERCIAL','SALES_MANAGER','SALES_ASSI','SALES_ASSI_MANAGER','SALES','FINANCE','CASHIER','MANAGER'],
        redDotFc: 'getAmountRedDoltNum',
        type:false,
        sonMenu: [
            {
                title: '发票开票',
                icon: 'el-icon-s-ticket',
                path: '/invoiceInfo',
                role: ['ADMIN','BUSINESS_COMMERCIAL','MANAGER'],
                redDotFc: 'getInvoiceRedDoltNum',
                type:'pending',
                sonMenu: []
            },
            {
                title: '发票退票',
                icon: 'el-icon-s-ticket',
                path: '/refundInfo',
                role: ['ADMIN','BUSINESS_COMMERCIAL','MANAGER'],
                redDotFc: 'getInvoiceRedDoltNum',
                type:'refund',
                sonMenu: []
            },
            {
                title: '资料邮寄/扫描',
                icon: 'el-icon-s-promotion',
                path: '/mailInfo',
                role: ['ADMIN','BUSINESS_COMMERCIAL','MANAGER'],
                redDotFc: 'getCourierRedDoltNum',
                type:false,
                sonMenu: []
            },
            {
                title: '到款信息',
                icon: 'el-icon-s-order',
                path: '/paymentInfo',
                redDotFc: 'getClaimRedDoltNum',
                type:false,
                role: ['ADMIN','FINANCE','CASHIER','SALES_MANAGER','SALES_ASSI','SALES_ASSI_MANAGER','SALES','MANAGER'],
                sonMenu: []
            },
            {
                title: '垫付款信息',
                icon: 'el-icon-s-platform',
                path: '/advanceInfo',
                redDotFc: 'getAdvanceRedDoltNum',
                type: false,
                role: ['ADMIN', 'FINANCE', 'CASHIER', 'SALES_MANAGER', 'SALES_ASSI', 'SALES_ASSI_MANAGER', 'SALES', 'MANAGER'],
                sonMenu: []
            },
        ]
    },
    {
        title: '物料管理',
        icon: 'el-icon-box',
        path: '/material',
        role: ['ADMIN','MANAGER','SALES_MANAGER','SALES_ASSI','SALES_ASSI_MANAGER','SALES','LAB','TECH'],
        redDotFc: 'getMaterialRedDoltNum',
        type:false,
        sonMenu: [
            {
                title: '物料词库',
                icon: 'el-icon-bank-card',
                path: '/lexicon',
                role: ['ADMIN','MANAGER','SALES_MANAGER','SALES_ASSI','SALES_ASSI_MANAGER','SALES','LAB','TECH'],
                sonMenu: []
            },
            {
                title: '物料入库',
                icon: 'el-icon-shopping-bag-1',
                path: '/stockIn',
                role: ['ADMIN','MANAGER','SALES_ASSI_MANAGER','SALES_ASSI'],
                sonMenu: []
            },
            {
                title: '物料申领',
                icon: 'el-icon-notebook-2',
                path: '/request',
                role: ['ADMIN','SALES_MANAGER','SALES_ASSI','SALES_ASSI_MANAGER','SALES','MANAGER'],
                redDotFc: 'getMailArrangeRedDoltNum',
                type:false,
                sonMenu: []
            },
            {
                title: '物料邮寄',
                icon: 'el-icon-receiving',
                path: '/requestMail',
                role: ['ADMIN','LAB','SALES_ASSI','SALES_ASSI_MANAGER','MANAGER'],
                redDotFc: 'getRequestMailRedDoltNum',
                type:false,
                sonMenu: []
            },
            {
                title: '干冰安排',
                icon:'el-icon-suitcase-1',
                path: '/dryIceArrange',
                role: ['ADMIN','MANAGER','SALES_ASSI_MANAGER','SALES_ASSI_MANAGER','SALES_ASSI'],
                redDotFc: 'getArrangeRedDoltNum',
                type:false,
                sonMenu: []
            },
        ]
    },
    {
        title: '公司信息',
        icon: 'el-icon-office-building',
        path: '/company',
        role: ['ADMIN','MANAGER','BUSINESS_COMMERCIAL','SALES_MANAGER','SALES_ASSI','SALES_ASSI_MANAGER','SALES','FINANCE','CASHIER'],
        sonMenu: []
    },
    {
        title: '销售资料',
        icon: 'el-icon-office-building',
        path: '/salesData',
        role: ['ADMIN','MANAGER','SALES_MANAGER','SALES_ASSI','SALES_ASSI_MANAGER','SALES','TECH'],
        sonMenu: []
    },
    {
        title: '合同模板',
        icon: 'el-icon-office-building',
        path: '/template',
        role: ['ADMIN', 'MANAGER', 'SALES_MANAGER', 'SALES_ASSI', 'SALES_ASSI_MANAGER', 'SALES', 'TECH', 'ANALYSE','AUDITOR'],
        sonMenu: []
    },
    {
        title: '报告模板',
        icon: 'el-icon-notebook-2',
        path: '/reportTem',
        role: ['ADMIN', 'MANAGER', 'SALES_MANAGER', 'SALES_ASSI', 'SALES_ASSI_MANAGER', 'SALES', 'TECH', 'ANALYSE','AUDITOR'],
        sonMenu: []
    },
    {
        title: '操作日志',
        icon: 'el-icon-document',
        path: '/log',
        role: ['ADMIN','MANAGER'],
        sonMenu: []
    },
    {
        title: '邮件管理',
        icon: 'el-icon-office-building',
        path: '/email',
        role: ['ADMIN'],
        sonMenu: []
    },
    {
        title: '系统配置',
        icon: 'el-icon-setting',
        path: '/sysConfig',
        role: ['ADMIN'],
        sonMenu: []
    },
    {
        title: '日历提醒',
        icon: 'el-icon-date',
        path: '/reminder',
        role: ['ADMIN','BUSINESS_COMMERCIAL'],
        sonMenu: []
    },
    {
        title: '更新日志',
        icon: 'el-icon-s-comment',
        path: '/updateLog',
        role: [],
        sonMenu: []
    }
    ]
export const mobileRoutesData = [
    {
        title: '合同信息',
        icon: 'completed-o',
        path: '/Contract',
        role: ['ADMIN', 'SALES_MANAGER', 'SALES_ASSI', 'SALES_ASSI_MANAGER', 'SALES', 'MANAGER'],
        redDotFc: '',
        sonMenu: []
    },
    {
        title: '签署记录',
        icon: 'records-o',
        path: '/signRecord',
        role: ['ADMIN', 'SALES_MANAGER', 'SALES_ASSI', 'SALES_ASSI_MANAGER', 'SALES', 'MANAGER'],
        redDotFc: '',
        sonMenu: []
    }
]
export const needRedDoltInfo = [
    {
        sys: 'CONTRACT',
        setRedDoltName: 'setContractRedDoltNum',
        role: ['ADMIN', 'MANAGER','APPROVAL_SPECIALIST'],
        type:'audit'
    },{
        sys: 'PENDING_REFUND_AUDIT',
        setRedDoltName: 'setInvoiceRedDoltNum',
        role: ['ADMIN','MANAGER'],
        type:'refundAudit'
    },{
        sys: 'INVOICE_RECORD',
        setRedDoltName: 'setRecordRedDoltNum',
        role: ['ADMIN','MANAGER','BUSINESS_COMMERCIAL'],
    },{
        sys: 'PENDING_INVOICED',
        setRedDoltName: 'setInvoiceRedDoltNum',
        role: ['ADMIN','BUSINESS_COMMERCIAL','MANAGER'],
        type:'pending',
    },{
        sys: 'PENDING_REFUND_INVOICE',
        setRedDoltName: 'setInvoiceRedDoltNum',
        role: ['ADMIN','BUSINESS_COMMERCIAL','MANAGER'],
        type:'refund'
    },{
        sys: 'COMPLEMENTS_CONTRACT',
        setRedDoltName: 'setContractRedDoltNum',
        role: [],
        type:'complements'
    },{
        sys: 'MAIL',
        setRedDoltName: 'setMailRedDoltNum',
        role: [],
    },{
        sys: 'PENDING_COURIER',
        setRedDoltName: 'setCourierRedDoltNum',
        role: ['ADMIN','BUSINESS_COMMERCIAL','MANAGER'],
    },{
        sys: 'COMPLEMENTS_CONTRACT',
        setRedDoltName: 'setComplementsRedDoltNum',
        role: ['ADMIN','MANAGER'],
    },{
        sys: 'MATERIAL_REQUEST_AUDIT',
        setRedDoltName: 'setRequestRedDoltNum',
        role: [],
    },{
        sys: 'PURE_ANALYSIS_AUDIT',
        setRedDoltName: 'setAnalysisRedDoltNum',
        role: ['ADMIN', 'ANALYSE','AUDITOR'],
    },{
        sys: 'MATERIAL_REQUEST_MAIL',
        setRedDoltName: 'setRequestMailRedDoltNum',
        role: ['ADMIN','SALES_ASSI','SALES_ASSI_MANAGER','LAB','MANAGER'],
    },{
        sys: 'SUBMITTED_INVOICE_AND_CONTRACT',
        setRedDoltName: 'setSubmittedRedDoltNum',
        role: ['SALES_MANAGER','SALES_ASSI','SALES_ASSI_MANAGER','SALES'],
    },{
        sys: 'PENDING_PAYMENT_CLAIM',
        setRedDoltName: 'setClaimRedDoltNum',
        role: ['ADMIN','FINANCE','CASHIER','SALES_MANAGER','SALES_ASSI','SALES_ASSI_MANAGER','SALES','MANAGER'],
        data:{
            "query#invoiceStatus.IN":"RECEIVABLES,PARTIAL_ARRIVAL"
        }
    },{
        sys: 'PAYMENT_CLAIM_AUDIT',
        setRedDoltName: 'setClaimAuditRedDoltNum',
        role: ['ADMIN','FINANCE','CASHIER','MANAGER'],
    },{
        sys: 'DRY_ICE_TO_BE_ARRANGED',
        setRedDoltName: 'setArrangeRedDoltNum',
        role: ['ADMIN','SALES_ASSI','SALES_ASSI_MANAGER','MANAGER'],
    },{
        sys: 'APPLYING_ARRANGED_MAIL',
        setRedDoltName: 'setMailArrangeDoltNum',
        role: ['ADMIN','SALES_MANAGER','SALES_ASSI','SALES_ASSI_MANAGER','SALES','MANAGER'],
    },{
        sys: 'CONTRACT_CHANGES_AUDIT',
        setRedDoltName: 'setContractChangeDoltNum',
        role: ['ADMIN', 'MANAGER', 'APPROVAL_SPECIALIST'],
    },{
        sys: 'TEAM_CONTRACT_AUDIT',
        setRedDoltName: 'setTeamAuditDoltNum',
        role: ['ADMIN', 'MANAGER', 'SALES_MANAGER'],
    },{
        sys: 'DEDUCTION_TO_BE_APPROVED',
        setRedDoltName: 'setOffSetDoltNum',
        role: ['ADMIN', 'MANAGER', 'APPROVAL_SPECIALIST'],
    }, {
        sys: 'CONTRACT_TERMINATE_AUDIT',
        setRedDoltName: 'setTerminateApplyDoltNum',
        role: ['ADMIN', 'MANAGER', 'LAB','APPROVAL_SPECIALIST'],
    },{
        sys: 'ADVANCE_PAYMENT_CLAIM_AUDIT',
        setRedDoltName: 'setAdvanceAuditRedDoltNum',
        role: ['ADMIN', 'FINANCE', 'CASHIER', 'MANAGER'],
    },{
        sys: 'ADVANCE_PAYMENT_INFO',
        setRedDoltName: 'setAdvanceRedDoltNum',
        role: ['ADMIN', 'FINANCE', 'CASHIER', 'SALES_MANAGER', 'SALES_ASSI', 'SALES_ASSI_MANAGER', 'SALES', 'MANAGER'],
        data:{
            "query#advancePaymentStatus.EQ":"PENDING_REFUND"
        }
    }
    // {
    //     sys: 'CONTRACT_SIGN_AUDIT',
    //     setRedDoltName: 'setSignDoltNum',
    //     role: ['ADMIN','MANAGER'],
    // }
]
